import React, { useState } from "react";
import TextField from "../../Components/customComponents/customTextField";
import Select from "../../Components/customComponents/customSelect";
import { useSelector, useDispatch } from "react-redux";
import FileUploadComponent from "../../Components/customComponents/customUpload";
import { upload_file_to_s3 } from "../../utils";
import { usaEmployeeSlice } from "../../store/reducers/usaEmployeeSlice";

const ACCOUNT_TYPE_OPTIONS = [
  { value: "Savings", label: "Savings" },
  { value: "Current", label: "Current" },
];

const UsaBankDetails = ({ onchange, isfilled }) => {
  const dispatch = useDispatch();

  const bankDetails = useSelector(
    (state) => state.usaEmployee.intialUsEmployee.bankDetails
  );

  const feildsDisabled = useSelector(
    (state) => state.usaEmployee.feildsDisabled
  );

  const [docLoader, setDocLoader] = useState({
    bankDocumentV1: false,
  });

  const handleNewUpload = async (new_file, label) => {
    const filename = new_file?.target?.name || "";
    const files = Array.from(new_file?.target?.files || []);
    if (files.length === 0) return;

    try {
      setDocLoader((prev) => ({ ...prev, [filename]: true }));

      const allowedTypes = [
        "application/pdf",
        "image/png",
        "image/jpeg",
        "image/jpg",
      ];
      const maxSize = 5 * 1024 * 1024; // 5MB
      const uploadedFiles = [];

      for (const file of files) {
        if (!allowedTypes.includes(file.type)) {
          alert("Only PDF, PNG, JPG files are allowed");
          continue;
        }
        if (file.size > maxSize) {
          alert("File size should be less than 5MB");
          continue;
        }

        const s3path = await upload_file_to_s3(file);
        uploadedFiles.push({
          fileName: filename,
          name: file.name,
          resourceName: label,
          uploadDate: new Date().toISOString(),
          comment: "",
          extension: file.name.split(".").pop(),
          s3Document: {
            ...(s3path?.data?.data || {}),
            originalFileName: file.name,
          },
        });
      }

      const existing = Array.isArray(bankDetails?.[filename])
        ? bankDetails[filename]
        : [];

      dispatch(
        usaEmployeeSlice.actions.updateDetails({
          name: filename,
          value: [...existing, ...uploadedFiles],
          directory: "bankDetails",
        })
      );

      setDocLoader((prev) => ({ ...prev, [filename]: false }));
    } catch (error) {
      console.error("File upload failed:", error);
      setDocLoader((prev) => ({ ...prev, [filename]: false }));
    }
  };

  const handleRemoveDoc = (filename, index) => {
    const existing = Array.isArray(bankDetails?.[filename])
      ? bankDetails[filename]
      : [];
    const updated = existing.filter((_, i) => i !== index);
    dispatch(
      usaEmployeeSlice.actions.updateDetails({
        name: filename,
        value: updated,
        directory: "bankDetails",
      })
    );
  };

  return (
    <div className="ml-10 mb-9">
      <p className="font-medium">BANK DETAILS</p>

      <div className="flex flex-col justify-evenly p-6 items-end justify-self-start">
        <TextField
          label={"Bank Name"}
          type={"text"}
          isMandatory={true}
          onChange={(e) => onchange(e, "bankDetails")}
          disabled={feildsDisabled}
          name={"bankName"}
          value={bankDetails.bankName}
          className={`${
            !bankDetails.bankName && isfilled
              ? "border border-red-500"
              : ""
          }`}
        />

        <TextField
          label={"Account Number"}
          type={"text"}
          isMandatory={true}
          onChange={(e) => onchange(e, "bankDetails")}
          disabled={feildsDisabled}
          name={"accountNumber"}
          value={bankDetails.accountNumber}
          className={`${
            !bankDetails.accountNumber && isfilled
              ? "border border-red-500"
              : ""
          }`}
        />

        <Select
          label={"Account Type"}
          options={ACCOUNT_TYPE_OPTIONS}
          isMandatory={false}
          onChange={(e) => onchange(e, "bankDetails")}
          disabled={feildsDisabled}
          name={"accountType"}
          value={bankDetails.accountType}
        />

        <TextField
          label={"Routing Number"}
          type={"text"}
          isMandatory={true}
          onChange={(e) => onchange(e, "bankDetails")}
          disabled={feildsDisabled}
          name={"routingNumber"}
          value={bankDetails.routingNumber}
          className={`${
            !bankDetails.routingNumber && isfilled
              ? "border border-red-500"
              : ""
          }`}
        />

        <TextField
          label={"Start Date"}
          type={"date"}
          isMandatory={true}
          onChange={(e) => onchange(e, "bankDetails")}
          disabled={feildsDisabled}
          name={"startDate"}
          value={bankDetails.startDate}
          className={`${
            !bankDetails.startDate && isfilled ? "border border-red-500" : ""
          }`}
        />

        <TextField
          label={"Current Residential Address"}
          type={"text"}
          isMandatory={true}
          onChange={(e) => onchange(e, "bankDetails")}
          disabled={feildsDisabled}
          name={"currentResidentialAddress"}
          value={bankDetails.currentResidentialAddress}
          className={`${
            !bankDetails.currentResidentialAddress && isfilled
              ? "border border-red-500"
              : ""
          }`}
        />

        <TextField
          label={"Savings Account"}
          type={"text"}
          isMandatory={false}
          onChange={(e) => onchange(e, "bankDetails")}
          disabled={feildsDisabled}
          name={"savingsAccount"}
          value={bankDetails.savingsAccount}
        />

        {/* NEW BANK DOCUMENT UPLOAD */}
        <FileUploadComponent
          name={"bankDocumentV1"}
          label={"Upload Bank Document"}
          handleUploade={(e) => handleNewUpload(e, "Bank Document")}
          isMandatory={false}
          isMultiple={true}
          isDisabled={feildsDisabled}
          files={
            Array.isArray(bankDetails.bankDocumentV1)
              ? bankDetails.bankDocumentV1
              : []
          }
          onRemove={(i) => handleRemoveDoc("bankDocumentV1", i)}
        />
      </div>
    </div>
  );
};

export default UsaBankDetails;